import UserActions from './user-actions';

export default UserActions;
